import { Component, OnInit } from '@angular/core';

import { UserService } from '@app/services/user.service';

import { ProjectService } from '@app/services/project.service';

import { ToastrService } from 'ngx-toastr';



@Component({

  selector: 'app-admin-user-management',

  templateUrl: './admin-user-management.component.html',

  styleUrls: ['./admin-user-management.component.scss']

})



export class AdminUserManagementComponent implements OnInit {

  users: any[] = [];

  customers: { CustomerShortCode: string; CustomerName: string }[] = [];

  error = '';

  loading = true;

  smeEdits: Record<number, { CustomerShortCode: string; assignedLicenses: number | null }> = {};

  savingSme: Record<number, boolean> = {};



  constructor(

    private userService: UserService,

    private projectService: ProjectService,

    private toastr: ToastrService,

  ) { }



  ngOnInit(): void {

    this.loadCustomers();

    this.loadUsers();

  }



  loadCustomers(): void {

    this.projectService.getCustomers().subscribe({

      next: (res: any[]) => {

        this.customers = Array.isArray(res) ? res : [];

      },

      error: () => {

        this.customers = [];

      },

    });

  }



  loadUsers() {

    this.userService.getAllUsers().subscribe({

      next: (res: any) => {

        this.users = res;

        for (const u of this.users) {

          const id = Number(u.userId);

          if (!this.smeEdits[id]) {

            this.smeEdits[id] = {

              CustomerShortCode: u.CustomerShortCode || '',

              assignedLicenses: u.assignedLicenses != null ? Number(u.assignedLicenses) : null,

            };

          }

        }

        this.loading = false;

      },

      error: () => {

        this.error = 'Failed to load users.';

        this.toastr.error('Failed to load users');

        this.loading = false;

      }

    });

  }



  saveSmeAssignment(user: any): void {

    const id = Number(user.userId);

    const edit = this.smeEdits[id];

    if (!edit) return;

    this.savingSme[id] = true;

    this.userService

      .assignSmeCustomerLicenses({

        userId: id,

        CustomerShortCode: String(edit.CustomerShortCode || '').trim(),

        assignedLicenses: edit.assignedLicenses,

      })

      .subscribe({

        next: (row: any) => {

          user.CustomerShortCode = row?.CustomerShortCode;

          user.assignedLicenses = row?.assignedLicenses;

          this.toastr.success('SME customer/license assignment saved');

          this.savingSme[id] = false;

        },

        error: (err) => {

          this.toastr.error(err?.error?.Data?.message || 'Failed to save assignment');

          this.savingSme[id] = false;

        },

      });

  }



  forChangeUserRole = {

    userid: '',

    user_type: ''

  };

  changeRole(user: any) {

    const roles = ['admin', 'designer', 'creator', 'SME'];

    const currentIndex = roles.indexOf(user.user_type);

    const newRole = roles[(currentIndex + 1) % roles.length];

    this.forChangeUserRole.userid = user.userId;

    this.forChangeUserRole.user_type = newRole;



    this.userService.changeRole(this.forChangeUserRole).subscribe({

      next: () => {

        this.toastr.success(`Role changed to ${newRole}`);

        this.forChangeUserRole = {

          userid: '',

          user_type: ''

        };



        this.loadUsers();

      },

      error: () => {

        this.toastr.error('Failed to change role');

      }

    });

  }

  forChangeUserStatus = {

    userid: '',

    user_status: ''

  };



  toggleStatus(user: any) {

    const newStatus = user.user_status === 'A' ? 'I' : 'A';

    this.forChangeUserStatus.userid = user.userId;

    this.forChangeUserStatus.user_status = newStatus;



    this.userService.changeStatus(this.forChangeUserStatus).subscribe({

      next: () => {

        this.toastr.success(`Status changed to ${newStatus}`);

        this.forChangeUserStatus = {

          userid: '',

          user_status: ''

        };



        this.loadUsers();

      },

      error: () => {

        this.toastr.error('Failed to change status');

      }

    });

  }

  newUser = {

    username: '',

    loginid: '',

    password: '',

    user_type: ''

  };



  addUser() {

    this.userService.addUser(this.newUser).subscribe({

      next: () => {

        this.toastr.success('User added successfully');

        this.newUser = {

          username: '',

          loginid: '',

          password: '',

          user_type: ''

        };

        this.loadUsers();

      },

      error: () => {

        this.toastr.error('Failed to add user');

      }

    });

  }

}


